const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const updateCampaignExtraData = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: CampaignExtraDataInput!) {
      updateCampaignExtraData(input:$input){
        internalStatus
        success
        error
      }
    }`,
    {
      input: queryVars,
    },
  )
}
